import React from "react";
import { NavLink } from "react-router-dom";

const PortfolioView = () => {
  return (
    <div className="w-100 portfolioView__card">
      <div className="project__sample_portfolio grid gap-2 lg:grid-cols-4 grid-cols-2">
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/2857306/pexels-photo-2857306.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/2106460/pexels-photo-2106460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/1385478/pexels-photo-1385478.jpeg?auto=compress&cs=tinysrgb&w=1600"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/1102388/pexels-photo-1102388.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/2857306/pexels-photo-2857306.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/2106460/pexels-photo-2106460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/1385478/pexels-photo-1385478.jpeg?auto=compress&cs=tinysrgb&w=1600"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/1102388/pexels-photo-1102388.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/2857306/pexels-photo-2857306.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/2106460/pexels-photo-2106460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/1385478/pexels-photo-1385478.jpeg?auto=compress&cs=tinysrgb&w=1600"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/1102388/pexels-photo-1102388.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/2857306/pexels-photo-2857306.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/2106460/pexels-photo-2106460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/1385478/pexels-photo-1385478.jpeg?auto=compress&cs=tinysrgb&w=1600"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
        <div className="project__sample__image">
          <NavLink to="/gallery">
            <img
              src="https://images.pexels.com/photos/1102388/pexels-photo-1102388.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-40 rounded-md cursor-pointer"
            />
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default PortfolioView;
